import { type AS400PreviewFormValues } from "@/screens/Companies/types/dialogProps"

export const AS400_FIELD_MAX_LENGTH: Readonly<Record<keyof AS400PreviewFormValues, number>> = {
  address1: 30,
  address2: 30,
  city: 20,
  name: 30,
  postalCode: 9,
  regionIsoCode: 2,
}
